import { Grid } from "@mui/material";
import React, { useState } from "react";
import { Feature } from "../../../../context/types";
import { useFeatureToggles } from "../../../../pages/shared/hooks/useFeatureToggles";
import { LanguageSelection } from "../../../widgets/language-selection";
import LoggedInUser from "../../../widgets/logged-in-user";
import Logo from "./logo";
import "./styles.scss";
import { HeaderProps } from "./types";
import GridMainLayout from "../../../widgets/grid";
import LanguageChooser from "../../../widgets/language-chooser";

const classNameBase = "scd-page-header";

export default function PageHeader({
  onLogin,
  onLogout,
  username,
  loginText,
  logoutText,
}: HeaderProps): React.JSX.Element {
  const [languageDrawerOpen, setLanguageDrawerOpen] = useState<boolean>(false);

  const canSwitchLanguage = useFeatureToggles(Feature.LOCALIZATION);

  return (
    <>
      <header className={classNameBase}>
        <GridMainLayout>
          <Grid size={{ xs: 6, md: 3 }}>
            <Logo />
          </Grid>
          <Grid size={{ xs: 6, md: 9 }}>
            <nav className={`${classNameBase}-menu-wrapper`}>
              {loginText && (
                <LoggedInUser
                  loginText={loginText}
                  logoutText={logoutText}
                  onLoginClick={onLogin}
                  onLogoutClick={onLogout}
                  username={username}
                />
              )}
              {canSwitchLanguage && (
                <LanguageChooser
                  languageDrawerOpenHandler={setLanguageDrawerOpen}
                />
              )}
            </nav>
          </Grid>
        </GridMainLayout>
      </header>
      {canSwitchLanguage && (
        <LanguageSelection
          open={languageDrawerOpen}
          onClose={() => setLanguageDrawerOpen(false)}
        />
      )}
    </>
  );
}
